import { collection, query, orderBy, getDocs, where, doc, updateDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import { db } from '../../firebase';
import CheckboxInput from '../../components/inputs/CheckboxInput';
import { useUser } from '../../contexts/UserContext';
import { handleCheckboxChange } from './CommonFunctions';

function UpdateOperateur({onClose, operateur}) {

  const user = useUser();

  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");

  //sites
  const [sites, setSites] = useState([]);
  const [operateurSites, setOperateurSites] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]); 

  const resetState = () => {
    setError("");
  }

  useEffect(() => {
    getSites();
  }, []); 

  useEffect(()=> {
    getSitesOperateur();
  }, [sites]); 

  useEffect(()=> {
    if(operateurSites.length>0){
      operateurSites.map((site) => {
        handleCheckboxChange(site, setSelectedSites);
        //todo on ajouter le map qu'il faut à l'utilisateur 
      }); 
    }
  }, [operateurSites]); 


  const getSitesOperateur = async () => {
    const collectionRef = query(collection(db, "utilisateurs/"+operateur.uid+"/sites"), where('active', '==', true), orderBy("nom"));

    try{
      let data = await getDocs(collectionRef); 

      if(data !== null){
        setOperateurSites(data.docs); 
      }
    }catch(err){
      console.log("error");
    } 
  }

  /**
   * Récupère l'ensemble des sites du client séléctionné
   */
  const getSites = async () => {
    //todo ajouter la verif active 1 dans la query 
    const collectionRef = query(collection(db, "utilisateurs/"+user.user.user.uid+"/sites"), where('active', '==', true), orderBy("nom"));

    try{
      let data = await getDocs(collectionRef); 
    
      if(data !== null){
        setSites(data.docs); 
      }
    }catch(err){
      console.log("error");
    } 
  }

  /**
   * On submit le formulaire
   * @param {*} e 
   */
  
  const handleSubmit = async (e)  => {
    
    e.preventDefault();

    try{
      setLoader(true);

      if(selectedSites.length > 0){
        //on ajoute le nouveau document avec un nouveau compte pour le syndic
        const operateurDoc = doc(db, "utilisateurs/"+user.user.user.uid+"/operateurs/"+operateur.id);

        await updateDoc(operateurDoc, {
          sites: selectedSites,
        }).then(async (doc) => {
          console.log("le doc updated")
        }).catch((err) => {
          setError("Une erreur est survenue, impossible de modifier le compte opérateur");
          setLoader(false);
          return; 
        });

        //le compte du chef est créé grâce à une fonction (cloud functions)
        
        setLoader(false);
        //on remet tous les states par défaut
        resetState(); 

        //on close la popup
        onClose(); 
      }else{
        setError("Il faut séléctionner un site minimum");
        setLoader(false);
        return; 
      }
    } catch(err){
      setError("Une erreur est survenue, impossible de créer le compte opérateur");
      setLoader(false);
    }
  };

  return (
    <div id="authentication-modal" tabIndex="-1" aria-hidden="true" className="mx-auto w-full fixed inset-0 flex items-center justify-center overflow-auto">
      <div className="relative w-full max-w-md max-h-full">
        <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <button type="button" onClick={onClose} className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-hide="authentication-modal">
            <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
            </svg>
            <span className="sr-only">Close modal</span>
          </button>
          <div className="px-6 py-6 lg:px-8">
            <h3 className="mb-4 text-xl font-medium text-gray-900 dark:text-white">Modifier les accès de l'opérateur {operateur.prenom} {operateur.nom} </h3>

            <form onSubmit={handleSubmit}>

              <div className='mb-6'>

                {sites.length > 0 ? (
                  <div className='mt-4'>
                    <label htmlFor="sites" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Sélectionnez un ou plusieurs sites</label>
                    {sites.map((site) => {

                      //vérif dans l'array selectedSites si l'element est dedans 
                      const checked = selectedSites.some((selectedSite) => selectedSite.id === site.id);

                      return (
                        <CheckboxInput key={site.id} label={site.data().nom} id={site.id} name={site.id} checked={checked} onChange={() => handleCheckboxChange(site, setSelectedSites)}/>
                      )
                    })}
                  </div>
                ) : null }
              </div>

              <div className="text-center">
                <PrimaryButton type={"submit"} value={"Modifier"} loading={loader} />
              </div>

              {error !== "" ? (
                <p className='justify-center flex my-1 text-red-500'>{error}</p>
              ) : null}
              
            </form>
          </div>
        </div>
      </div>
    </div> 
  );
}

export default UpdateOperateur;